import {
  TaskPriority,
  taskPrioritySchema,
} from '@/task-manager/entities/task-priority';

export function taskPriorityMapper(data: string): TaskPriority {
  return taskPrioritySchema.parse(data);
}
